import Base from './base'
import renderFields from './audio-finish.pug'

export default class AudioFinish extends Base
  @label: "音檔結束"

  renderFields: renderFields
